export default __webpack_public_path__ + "static/media/1820.05eab6cc.png";